import { z } from "zod";
import { TaskType } from "@remi/enums/task-type";

export const InstallStartedTaskAttemptSchema = z.object({
  type: z.literal(TaskType.INSTALL_STARTED),
  materialsCost: z.number().nullable().optional(),
  materialsReceiptFileIds: z.array(z.string()).nullable().optional(),
  installStartedAt: z.coerce.date(),
  billId: z.string().nullable().optional(),
});
